<template>
  <div class="layout-box">
    <LayoutHeader headtitle="行业专家"></LayoutHeader>
    <div class="secondary-content">
      <GoBack></GoBack>
      <div class="experts-title">
        <div class="bread-crumb-nav">当前位置：首页 > <a @click="$router.back()">托盘商城</a> > 商品详情</div>
      </div>
      <div class="purchase-intention-table" :class="isshow?'purchase-intention-show':''">
        <div class="experts-title" @click="hiddendisplaypi(false)"><h4>意向单</h4></div>
        <div class="pi-table-c">
          <p><label>地址</label><input name="" placeholder="送货地址" v-model="orderAddress"></p>
          <p><label>联系人</label><input name="" placeholder="联系人" v-model="orderContact"></p>
          <p><label>联系电话</label><input name="" placeholder="联系电话" v-model="orderContactPhone"></p>
          <p><label>托盘数量</label><input name="" placeholder="托盘数量" v-model="orderNum" type="number"></p>
          <p v-if="malldata.itemType==1"><label>租赁天数</label><input name="" placeholder="租赁天数" v-model="leaseDay" type="number"></p>
          <span @click="submits()">提交</span>
        </div>
      </div>
      <div class="experts-detail">
        <span class="purchase-intention" @click="hiddendisplaypi(true)" title="点击发起意向单">发起意向单</span>
        <div class="character-profile clear" @click="hiddendisplaypi(false)">
<!--          <img :src='malldata.attachments[0].url' width="300"/>-->
          <div class="shuffling">
            <swiper :options="swiperOption">
              <swiper-slide v-for="(item,index) in malldata.attachments" :key="index"><img :src="item.url"></swiper-slide>
            </swiper>
          </div>
          <div class="character-profile-div">
            <h3>{{ malldata.itemName }}</h3>
            <p><b>价格：</b><font class="red">￥<strong style="font-size: 21px">{{ malldata.itemPrice }}</strong>/{{malldata.itemType==2?'个':'天'}}</font></p>
            <p><b>库存：</b>{{ malldata.itemStock }}</p>
            <p><font class="red">使用寿命3年+</font></p>
            <p class="research">{{ malldata.itemDesc }}</p>
          </div>
        </div>
        <div>&nbsp;</div>
        <div class="main-works" @click="hiddendisplaypi(false)">
          <h3>规格参数:</h3>
          <span class="icons-fxg"></span>
        </div>
        <div class="details-introduction" @click="hiddendisplaypi(false)">
          <div><label>托盘名称：</label>{{malldata.itemName}}</div>
          <div><label>长度：</label>{{malldata.specLength}} mm</div>
          <div><label>宽度：</label>{{malldata.specWidth}} mm</div>
          <div><label>高度：</label>{{malldata.specHeight}} mm</div>
          <div><label>重量：</label>{{malldata.specWeight}} kg</div>
          <div><label>静载：</label>{{malldata.staticLoad}} kg</div>
          <div><label>动载：</label>{{malldata.dynLoad}} kg</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LayoutHeader from './pallet-header'
import GoBack from "../layout/layout-goback";
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'MatchingExpertsD',
  components:{
    LayoutHeader,
    GoBack,
    swiper,
    swiperSlide
  },
  data () {
    return {
      malldata:'',
      explistdata:null,
      isshow:false,
      swiperOption: {//swiper3
        autoplay: 3000,
        speed: 1000
      },
      orderAddress:'',//下单地址
      orderContact:'',//联系人
      orderContactPhone:'',//联系电话
      orderNum:'',//托盘数量
      leaseDay:'',//租赁天数
    }
  },
  mounted () {
    this.explistdata=JSON.parse(localStorage.getItem('expdata'))
    let ids=this.$route.query.id||''
    if(ids){
      this.getmalldetail(ids)
    }
  },
  methods:{
    getmalldetail(ids){
      let $this=this
      const urls = '/mall/traySaleItem/mobile/getSaleItemAndAssociateInfoById.html'
      this.$api.get(urls, {userId:300004432,token:'0e24d657c8b144b3a22521590906833f300004432',itemId:ids}, (response) => {
        $this.malldata=response.data.data||''
      })
    },
    hiddendisplaypi(t){
      this.isshow=t
    },
    submits(){
      let $this=this
      if(!(/^1[3456789]\d{9}$/.test($this.orderContactPhone))){
        this.$alert('手机格式不正确')
        return
      }
      if($this.orderNum==''){
        this.$alert('托盘数量不能为空')
        return
      }
      if($this.orderAddress==''){
        this.$alert('地址不能为空')
        return
      }
      if($this.orderContact==''){
        this.$alert('联系人不能为空')
        return
      }
      if($this.leaseDay==''&&$this.malldata.itemType==1){
        this.$alert('租赁天数不能为空')
        return
      }
      let opt={
        userId:300004432*1,
        token:'0e24d657c8b144b3a22521590906833f300004432',
        userName:'华瑞中心',
        orderType:1,
        orderContact:$this.orderContact,
        itemId:$this.malldata.itemId,
        orderContactPhone:($this.orderContactPhone).toString(),
        orderNum:$this.orderNum*1,
        orderAddress:$this.orderAddress,
        saleType:$this.malldata.itemType
      }
      if($this.malldata.itemType==1){
        opt[leaseDay]=$this.leaseDay
      }
      const urls = '/mall/traySaleOrder/mobile/insertSaleOrder.html'
      this.$api.post(urls, opt, (response) => {
        let st=response.data.status||''
        if(st==1){
          this.$alert('提交成功！请耐心等待');
        }
      },'json')
    }
  }
}
</script>

<style scoped>
.layout-box {
  position: relative;
  width: 100%;
  height: calc(100% - 170px);
  padding-top: 170px;
  background: url("../../assets/erj_bj.fw.png");
}

.secondary-content{
  width: 1100px;
  height: 100%;
  margin: 0 auto;
  position: relative;
  background: #fff;
}

.experts-title{
  width:100%;
  height: 59px;
  background-image: linear-gradient(rgba(239,243,254,.2),rgba(197,210,250,.48));
}

.experts-title h4{
  color: #fff;
  line-height: 59px;
  text-align: center;
  font-size: 21px;
  letter-spacing: 5px;
  text-shadow:0 4px 5px rgba(0, 0, 0, 0.3);
}

.bread-crumb-nav{
  font-size: 16px;
  font-family: 微软雅黑;
  line-height: 59px;
  padding-left: 20px;
}

.bread-crumb-nav a{
  cursor: pointer;
  text-decoration: none;
}
.bread-crumb-nav a:hover{
  text-decoration: underline;
  font-weight: bold;
}

.experts-detail{
  width: 100%;
  font-size: 16px;
  line-height: 217%;
  overflow: auto;
  height: calc(100% - 60px);
  position: relative;
}

.experts-detail::-webkit-scrollbar{
  display: none;
}

.character-profile{
  width: calc(100%-40px);
  height: 248px;
  padding: 40px 50px;
  cursor: pointer;
  box-shadow:0 4px 8px 0 rgba(100, 100, 100, 0.1), 0 6px 20px 0 rgba(100, 100, 100, 0.1);
  float: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.character-profile-div{
  margin-left: 20px;
  display: flex;
  flex-wrap: wrap;
}

.character-profile h3{
  font-size: 26px;
  margin-bottom: 15px;
}

.character-profile p{
  line-height: 160%;
  width: 780px;
  margin: 3px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.character-profile p.research{
  white-space:normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  word-break: break-all;
  color: #777;
}

.main-works{
  padding: 0 10px 15px 10px;
  margin: 0 40px;
  border-bottom: 1px solid #E3E9F6;
  position: relative;
}

.main-works p{
  margin-top: 15px;
}

.details-introduction{
  padding: 20px;
  margin: 0 40px;
  background: #F6F6F6;
}

.icons-fxg{
  position: absolute;
  top: 7px;
  right: 0;
  width: 261px;
  height: 147px;
  background: url("../../assets/tit-1.png") no-repeat center/100%;
}

.red{
  color: #E4393C;
}

.shuffling{
  width: 300px;
  max-height: 450px;
  overflow: hidden;
  flex-shrink:0
}

.swiper-container{
  width: 303px;
}

.shuffling .swiper-container img{
  width: 300px;
}

.purchase-intention{
  height: 44px;
  position: absolute;
  line-height: 44px;
  font-size: 18px;
  color: #fff;
  background: #E54D42;
  padding: 0 46px;
  border-radius: 5px;
  z-index: 5;
  top:221px;
  right: 40px;
  cursor: pointer;
}

.purchase-intention:hover{
  text-shadow: 2px 2px 4px rgba(0,0,0,.4);
  background: #E6564A;
}

.purchase-intention-table{
  position: absolute;
  right: -800px;
  top: 0px;
  width: 320px;
  background: #fff;
  opacity: 0;
}

.purchase-intention-table .experts-title{
  background-image: linear-gradient(rgba(66,112,198,.7),rgba(11,66,175,0.8));
}

.purchase-intention-show{
  right: -400px;
  opacity: 1;
  transition: right .5s;
}

.pi-table-c{
  padding: 5px 8px 20px 8px;
}

.pi-table-c p{
  padding: 8px 10px 4px 12px;
  border-bottom: 1px solid #eee;
}

.pi-table-c input{
  border: 0;
  height: 30px;
  line-height: 30px;
  padding: 5px 8px;
  outline: 0;
}

.pi-table-c span{
  background: #F27813;
  width: 204px;
  height: 46px;
  display: inline-block;
  border-radius: 8px;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  text-align: center;
  line-height: 46px;
  margin-left: 50px;
  margin-top: 15px;
}

.pi-table-c span:hover{
  background: #F38529;
}

</style>




// WEBPACK FOOTER //
// src/views/pallet/pallet-mall-detail.vue